import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './Badge.module.scss';

const Badge = ({ theme = {}, type, text }) => {
  if (!type || !text) return null;

  return (
    <span
      className={classNames(
        style.badge,
        theme.badge,
        style[`${type}-badge`],
        theme[`${type}-badge`],
      )}
    >
      {text}
    </span>
  );
};

Badge.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.shape({}),
  type: PropTypes.string,
};

export default Badge;
